// Vite doesn't define a global field on window like Webpack does,
// therefore we should include this script anywhere `global.window` is used
window.global = window?.global ?? window;